module.exports = __webpack_public_path__ + "static/media/wiser-logo-dark-background.ed3d0668.png";